import type {ListValueEditorLocalizations, ListValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';
import type {TextValueEditorOptions, TextValueEditorValidations} from '../../editors/text/types';

/**
 * @ngdoc constant
 * @name LIST_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.list
 *
 * @description
 * For description see {@link ListValueEditorOptions}
 *
 * ```javascript
 * {
 *   subEditor: {type: 'text'},
 *   newItemPrototype: '',
 *   onAddItem: undefined,
 *   sendWholeForm: false,
 *   additionalParameters: undefined
 * }
 * ```
 */
export const LIST_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<ListValueEditorOptions<string, TextValueEditorOptions, TextValueEditorValidations>> = {
    subEditor: {type: 'text'},
    newItemPrototype: '',
    onAddItem: undefined,
    sendWholeForm: false,
    additionalParameters: undefined,
    autoCreateNewItemIfRequired: true
};

/**
 * @ngdoc constant
 * @name LIST_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.list
 *
 * @description
 * ```
 * {
 *     add: 'Add',
 *     remove: 'Remove'
 *     required: 'required',
 *     item: 'item',
 * }
 * ```
 */
export const LIST_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<ListValueEditorLocalizations>({
    add: 'Add',
    remove: 'Remove',
    required: 'required',
    item: 'item',
    description: ''
});
